import type { BreadCrumbLink } from './types';

export const mapToLink = (
  breadCrumb: Oneflow.Folder | Oneflow.Workspace | BreadCrumbLink,
): BreadCrumbLink => ({
  id: breadCrumb.id,
  label: breadCrumb.name,
  to: '',
});
